"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

exports.__esModule = true;
exports["default"] = void 0;

var _inheritsLoose2 = _interopRequireDefault(require("@babel/runtime/helpers/inheritsLoose"));

var _react = _interopRequireDefault(require("react"));

var _text = require("@mmc/text");

var _mmcDataUtilities = _interopRequireDefault(require("@mmc-tools/mmc-data-utilities"));

var _configuratorPackageSelectorCardWrapper = _interopRequireDefault(require("./configurator-package-selector-card-wrapper"));

var _configuratorPackageSelector = _interopRequireDefault(require("../styles/configurator-package-selector.css"));

var _configuratorPackageSelector2 = require("./configurator-package-selector.props/configurator-package-selector.propTypes");

var _DataUtils = new _mmcDataUtilities["default"](),
    handleNestedProp = _DataUtils.handleNestedProp,
    isEmptyArray = _DataUtils.isEmptyArray;

var ConfiguratorPackageSelector = /*#__PURE__*/function (_React$Component) {
  (0, _inheritsLoose2["default"])(ConfiguratorPackageSelector, _React$Component);

  function ConfiguratorPackageSelector() {
    return _React$Component.apply(this, arguments) || this;
  }

  ConfiguratorPackageSelector.resourceType = function resourceType() {
    return 'PackagesSelector_1_0_0';
  };

  var _proto = ConfiguratorPackageSelector.prototype;

  _proto.createEvenOddArray = function createEvenOddArray(optionsArray) {
    var sortedArray = optionsArray.reduce(function (acc, obj, i) {
      if (i % 2) {
        // eslint-disable-line
        // eslint-disable-next-line no-return-assign
        return acc = {
          right: [].concat(acc.right, [obj]),
          left: [].concat(acc.left)
        };
      } // eslint-disable-next-line no-return-assign


      return acc = {
        right: [].concat(acc.right),
        left: [].concat(acc.left, [obj])
      };
    }, {
      left: [],
      right: []
    });
    return sortedArray;
  };

  _proto.renderPackages = function renderPackages(filteringOptions, forcedOptionCodes, notCompatibleOptionCodes, theme, addPriceDisclaimer, priceDisclaimerId, disclaimerData) {
    var sortedObject = this.createEvenOddArray(filteringOptions);
    var _this$props = this.props,
        _this$props$changeEve = _this$props.changeEvent,
        changeEvent = _this$props$changeEve === void 0 ? null : _this$props$changeEve,
        _this$props$selectedP = _this$props.selectedPackages,
        selectedPackages = _this$props$selectedP === void 0 ? [] : _this$props$selectedP;
    return /*#__PURE__*/_react["default"].createElement("div", {
      className: "" + theme.row
    }, /*#__PURE__*/_react["default"].createElement("div", {
      className: theme['col-xs-12'] + " " + theme['col-sm-6']
    }, sortedObject.left && sortedObject.left.map(function (element) {
      return /*#__PURE__*/_react["default"].createElement(_configuratorPackageSelectorCardWrapper["default"], {
        filterPackage: element,
        changeEvent: changeEvent,
        selectedPackages: selectedPackages,
        forcedOptionCodes: forcedOptionCodes,
        notCompatibleOptionCodes: notCompatibleOptionCodes,
        key: element.code,
        theme: theme,
        addPriceDisclaimer: addPriceDisclaimer,
        priceDisclaimerId: priceDisclaimerId,
        disclaimerData: disclaimerData
      });
    })), /*#__PURE__*/_react["default"].createElement("div", {
      className: theme['col-xs-12'] + " " + theme['col-sm-6']
    }, sortedObject.right && sortedObject.right.map(function (element) {
      return /*#__PURE__*/_react["default"].createElement(_configuratorPackageSelectorCardWrapper["default"], {
        filterPackage: element,
        changeEvent: changeEvent,
        selectedPackages: selectedPackages,
        forcedOptionCodes: forcedOptionCodes,
        notCompatibleOptionCodes: notCompatibleOptionCodes,
        key: element.code,
        theme: theme,
        addPriceDisclaimer: addPriceDisclaimer,
        priceDisclaimerId: priceDisclaimerId,
        disclaimerData: disclaimerData
      });
    })));
  };

  _proto.render = function render() {
    var _this$props2 = this.props,
        data = _this$props2.data,
        theme = _this$props2.theme,
        addPriceDisclaimer = _this$props2.addPriceDisclaimer,
        priceDisclaimerId = _this$props2.priceDisclaimerId,
        disclaimerData = _this$props2.disclaimerData,
        notCompatibleOptionCodes = _this$props2.notCompatibleOptionCodes;
    var forcedOptionCodes = data.forcedOptionCodes;
    var filterOptions = handleNestedProp(data, 'data.filter.filteringOptions');
    filterOptions = isEmptyArray(filterOptions) ? [] : filterOptions;
    var headingTextTitle = handleNestedProp(data, 'data.headingText.title');
    return /*#__PURE__*/_react["default"].createElement("fieldset", {
      className: "" + _configuratorPackageSelector["default"].packageSelectorContainer
    }, /*#__PURE__*/_react["default"].createElement(_text.Text, {
      className: _configuratorPackageSelector["default"].legend,
      text: headingTextTitle !== ' ' && headingTextTitle,
      tag: "legend",
      disclaimerData: disclaimerData
    }), this.renderPackages(filterOptions, forcedOptionCodes, notCompatibleOptionCodes, theme, addPriceDisclaimer, priceDisclaimerId, disclaimerData));
  };

  return ConfiguratorPackageSelector;
}(_react["default"].Component);

exports["default"] = ConfiguratorPackageSelector;
ConfiguratorPackageSelector.displayName = 'ConfiguratorPackageSelector';